import React, { Dispatch, SetStateAction, useEffect } from "react";
import { Stack, Text } from "@chakra-ui/react";

import { useForm, FormProvider } from "react-hook-form";
import { useAuth } from "src/shared/contexts/AuthContext";
import useTranslation from "next-translate/useTranslation";
import { Button } from "src/shared/components/Button";
import { SmileSignUpSteps } from "../..";
import { SIGN_UP_STEP } from "src/shared/contexts/AuthContext";
import * as GTagHelper from "src/utils/helpers/GTagHelper";
import { track } from "src/services/Segment/analytics";
import { useSentry } from "src/services/Sentry";
import { FormInput } from "src/shared/components/FormInput";
import SmileSignupPasswordInput from "../Controls/Create/SmileSignupPasswordInput";
import SmileSignupValidatePasswordInput from "../Controls/Create/SmileSignupValidatePasswordInput";
import SmileSignupCreateLink from "../Controls/SmileSignupCreateLink";

interface FormData {
  email: string;
  password: string;
  validatePassword: string;
}

const SmileSignupCreateForm = ({ setStep }: { setStep: Dispatch<SetStateAction<SmileSignUpSteps>> }) => {
  const { t } = useTranslation();
  const formMethods = useForm<FormData>({
    mode: "onBlur",
  });
  const { handleSubmit, setError, formState } = formMethods;
  const [{ errorMessages }, { signUp }] = useAuth();
  const { log } = useSentry();

  const onSubmit = handleSubmit(async ({ email, password }) => {
    const res = await signUp(email, password);

    if (res === SIGN_UP_STEP.NEW_ACCOUNT) {
      try {
        GTagHelper.event({
          action: "FRONT | New SignUp | STEP 1",
          category: "SIGNUP",
          payload: { email },
        });
        if (typeof window.analytics !== "undefined")
          track("FRONT | New SignUp | STEP 1", {
            email,
          });
      } catch (e: any) {
        log(e, "error");
      }
      setStep(SmileSignUpSteps.INFOS_STEP);
    }
  });

  useEffect(() => {
    if (errorMessages.length !== 0) {
      errorMessages.forEach((value) => {
        const field = value.includes("email") ? "email" : "password";
        setError(field, {
          type: "manual",
          message: value,
        });
      });
    }
  }, [errorMessages.length]);

  return (
    <FormProvider {...formMethods}>
      <form onSubmit={onSubmit}>
        <Text
          fontFamily="Montserrat"
          fontStyle="normal"
          fontWeight="normal"
          fontSize="18px"
          lineHeight="22px"
          pb="20px"
        >
          {t("smile:smileSignup_stepOneSubtitle")}
        </Text>
        <Stack align="center" spacing="50px">
          <FormInput name="email" type="email" label={t("smile:pixSignup_emailLabel")} />
          <SmileSignupPasswordInput />
          <SmileSignupValidatePasswordInput />
          <Button type="submit" isLoading={formState.isSubmitting} isFullWidth={true}>
            {t("smile:pixSignup_goButton")}
          </Button>
          <SmileSignupCreateLink />
        </Stack>
      </form>
    </FormProvider>
  );
};

export default SmileSignupCreateForm;
